<template>
  <div>
    <!-- Popup -->
    <vs-popup :title="`${action_name} ${module_name}`" button-accept="false" button-cancel="false" :active.sync="isActive">
      <form method="POST" @submit.prevent="save_changes">
        <div class="vx-row">
          <div class="vx-col w-full px-8">
            <!-- Category -->
            <div class="vx-row mb-2">
              <label class="vs-input--label">Category *</label>
              <select-2
                class="w-full"
                :name="'category'"
                placeholder="Select Category"
                v-validate="'required'"
                :options="CATEGORIES"
                autocomplete
                :ssr="true"
                :multiple="false"
                :value="form.category"
                data-vv-as="Category"
                @input="(item) => (form.category = item && item.value)"
              />
              <span class="text-danger text-sm" v-show="errors.has(`category`)">{{ errors.first(`category`) }}</span>
            </div>

            <!-- Title -->
            <div class="vx-row mb-2">
              <vs-input
                placeholder=" Punjabi Powerhouse"
                class="w-full"
                v-validate="'required|exclude_special_char|min:4'"
                v-model="form.title"
                label="Title *"
                name="title"
                data-vv-as="Title"
                id="Title"
              />
              <span class="text-danger text-sm" v-show="errors.has('title')">{{ errors.first('title') }}</span>
            </div>

            <!-- Audio -->
            <div class="vx-row mb-2">
              <label class="vs-input--label">Audio *</label>
              <select-2
                class="w-full category-input"
                name="audio"
                placeholder="Select Audio"
                :value="form.audio"
                @input="(item) => (form.audio = item && item.value)"
                autocomplete
                :ssr="true"
                :multiple="true"
                :clearable="!!form.audio.length"
                v-validate="'required'"
                action="audio/get"
                :params="{ audioIds: JSON.stringify(form.audio) }"
                data-vv-as="Audio"
              />
              <span class="text-danger text-sm" v-show="errors.has('audio')">{{ errors.first('audio') }}</span>
            </div>
            <!-- Description -->
            <div class="vx-row mb-2">
              <label class="vs-input--label" for="description">Description *</label>
              <vs-textarea
                placeholder="Get ready to groove to the hottest Punjabi beats! This playlist features a mix of classic bhangra hits, chart-topping tracks, and rising Punjabi stars."
                class="w-full mb-0"
                id="description"
                v-validate="'required|exclude_special_char'"
                name="description"
                v-model="form.description"
                data-vv-as="Description"
                :rows="3"
              />
              <span class="text-danger text-sm" v-show="errors.has('description')">{{ errors.first('description') }}</span>
            </div>
          </div>

          <div class="vx-col w-full cursor-pointer">
            <label class="vs-input--label block">Image *</label>
            <input
              :key="fileKey"
              type="file"
              class="border p-2 rounded w-full"
              ref="files"
              accept=".jpg, .png , .jpeg"
              @change="handleFileUpload"
              style="border: 1px solid rgba(0, 0, 0, 0.2)"
              data-vv-as="Image"
            />
            <input type="hidden" name="image" v-model="form.image" v-validate="imagevalidationRule" data-vv-as="Image" />
            <span class="text-danger text-sm" v-show="errors.has('image')">{{ errors.first('image') }}</span>
            <div class="mt-5">
              <div class="relative" v-if="preview_image">
                <div class="h-64 w-64 mt-5 overflow-hidden">
                  <img height="200px" width="250px" :src="preview_image" alt="image" class="object-fit" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="vx-row pt-5 px-5 text-center">
          <div class="vx-col w-full">
            <div class="items-center">
              <vs-button class="mr-2 vs-con-loading__container" id="create-playlist" @click="save_changes">{{ action_name }}</vs-button>
              <vs-button color="danger" class="text-left" @click="navigateList">Cancel</vs-button>
            </div>
          </div>
        </div>
      </form>
    </vs-popup>
    <vs-popup title="Image Cropper" name="Image" :active.sync="IsOpenImageCrop" class="image-cropper" style="z-index: 55000">
      <div class="text-center flex justify-center w-full h-full">
        <!-- modal content -->
        <div class="modal__content w-full h-full">
          <!-- modal body -->
          <div class="modal-body w-full h-full">
            <div class="modal-form w-full h-full">
              <div class="w-full h-full max-h-450">
                <cropper
                  ref="cropper"
                  name="Image"
                  class="cropper-image"
                  :src="this.crop_image.src"
                  :stencil-props="{
                    aspectRatio: 12 / 12
                  }"
                />
              </div>
              <div class="button-wrapper mt-3">
                <vs-button type="" @click="cropImage()" class="text-primary border border-solid border-primary">Crop Image</vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

export default {
  /** Page Name */
  name: `playlistAction`,

  /** components */
  components: {
    Select2,
    Cropper
  },

  /** Props */
  props: {
    showModal: Boolean,
    data: Object,
    module_name: String,
    action_name: String
  },

  /** data */
  data() {
    return {
      fileKey: 0,
      form: {
        title: '',
        image: null,
        audio: [],
        category: null,
        description: ''
      },
      preview_image: null,
      CATEGORIES: [],
      crop_image: {
        src: '',
        type: '',
        isRound: true
      },
      IsOpenImageCrop: false
    }
  },

  /** created */
  async created() {
    if (this.data) {
      this.form.category = this.data.category ? this.data.category : ''
      this.form.title = this.data.title ? this.data.title : ''
      this.form.audio = this.data.audio ? this.data.audio : []
      this.preview_image = this.data.image ? this.data.image : null
      this.form.description = this.data.description ? this.data.description : ''
    }
    const { audio } = await this.getPreDefinedValues()
    this.CATEGORIES = audio.category.map((value) => {
      return {
        value,
        label: value
      }
    })
  },
  /** computed */
  computed: {
    ...mapState('playlist', ['createLoading']),
    validateForm() {
      return !this.errors.any()
    },
    isActive: {
      get() {
        return this.showModal
      },
      set(val) {
        this.$emit('update:showModal', val)
      }
    },
    imagevalidationRule() {
      return !this.data ? 'required' : ''
    }
  },

  /** methods */
  methods: {
    ...mapActions('playlist', {
      create: 'create',
      update: 'update'
    }),
    ...mapActions('common', {
      getPreDefinedValues: 'getPreDefinedValues'
    }),
    navigateList() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Cancel`,
        text: `Are you sure you want to cancel?`,
        accept: () => {
          this.isActive = false
        },
        acceptText: 'Yes',
        cancelText: 'No'
      })
    },
    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      if (!this.data && !this.form.image) {
        this.$vs.notify({
          title: 'Error',
          text: 'Image Is Required!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        const data = new FormData()

        for (const key in this.form) {
          if (this.form[key]) {
            if (typeof this.form[key] === 'object' && key != 'image') {
              this.form[key].map((item) => {
                data.append(`${key  }[]`, item)
              })
            } else {
              data.append(key, this.form[key])
            }
          }
        }
        let result
        if (!this.data) {
          result = await this.create(data)
        } else {
          result = await this.update({
            id: this.data._id,
            data
          })
        }
        const message = result.message
        this.$emit('update-data', true)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.isActive = false
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    /** file upload  */
    handleFileUpload(e) {
      const file = e.target.files[0]

      // Check if a file is selected
      if (!file) {
        this.$vs.notify({
          title: 'Error',
          text: 'No file selected',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }
      const blob = URL.createObjectURL(file)

      this.crop_image = {
        src: blob,
        type: file.type
      }
      // e.target.value = ''
      this.IsOpenImageCrop = true

      // Increment fileKey to force re-render
      this.fileKey++
    },
    cropImage() {
      const result = this.$refs.cropper.getResult()
      if (result.canvas == undefined) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please Select Image',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }
      const resultTest = result.canvas.toDataURL(this.crop_image.type)
      const base64Image = resultTest.replace(`data:${this.crop_image.type};base64,`, '')
      this.b64toBlob(base64Image, this.crop_image.type)

      this.IsOpenImageCrop = false
    },
    b64toBlob(b64Data, contentType = '', sliceSize = 512) {
      const byteCharacters = window.atob(b64Data)
      const byteArrays = []

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)

        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }

      const blob = new File(byteArrays, 'image.jpg', {
        type: contentType
      })
      this.form.image = blob
      this.preview_image = URL.createObjectURL(blob)
      return blob
    }
  },

  /** watch */
  watch: {
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#create-playlist',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#create-playlist > .con-vs-loading')
      }
    }
  }
}
</script>
<style>
.cropper-image {
  height: 400px;
  background: #ddd;
}
</style>
